export const DOCTRINE_PURPOSE = {
  title: "Purpose of Doctrine",
  definition:
    "Doctrine is the backbone of the believer. It is what foundation is to a building — for solidity, stability, security, strength and substance.",
  attitudes: [
    "Possess it",
    "Pursue it",
    "Practice it",
    "Proclaim it",
    "Preserve in upholding it",
    "Preserve it (Proverbs 30:5–6)",
    "Preach it — pass it on to others (Deuteronomy)",
  ],
};

export const DOCTRINE_ACRONYMS = [
  {
    word: "DOCTRINES",
    columns: [
      { letter: "D", items: ["Decree / Declaration", "Development", "Defend it · Desire it"] },
      { letter: "O", items: ["Oracle / Ordinance", "Organisation", "Observe it · Obey it"] },
      { letter: "C", items: ["Commandment · Creed", "Correction", "Continue in it"] },
      { letter: "T", items: ["Truth · Teachings", "Transformation", "Teach it · Treasure it"] },
      { letter: "R", items: ["Revelation", "Reprove", "Receive it"] },
      { letter: "I", items: ["Instruction", "Instruction", "Internalize it · Inbibe it"] },
      { letter: "N", items: ["Norms for Christians", "Nurture", "Need it"] },
      { letter: "E", items: ["Epistles", "Edification", "Emphasized"] },
      { letter: "S", items: ["Sayings · Scriptures", "Salvation", "Search it · Seek it · Study it"] },
    ],
  },
];

export const CHURCH_DOCTRINES = [
  {
    id: 1,
    title: "The Holy Bible",
    summary:
      "The Holy Bible contains 39 books in the Old Testament and 27 in the New Testament. It is the inspiration of God and the final authority for Christians — a light that guides, spiritual food, salvation, a shield, and a manual for living.",
    scriptures: ["Psalm 119:105", "John 15:7", "2 Timothy 3:16–17", "1 Peter 1:23–25", "Joshua 1:6–8"],
  },
  {
    id: 2,
    title: "The Godhead",
    summary:
      "The Bible teaches that the Trinity is the revelation and manifestation of God Himself — God the Father, God the Son, and God the Holy Spirit. He is the Creator who reveals Himself to sinners and restores fellowship through Christ.",
    scriptures: ["Genesis 1:1–3", "John 1:1–5", "Matthew 28:19", "2 Corinthians 13:14"],
  },
  {
    id: 3,
    title: "The Virgin Birth of Jesus",
    summary:
      "Jesus was born of God without human chromosomes or the trait and genes of Adam. He was conceived by the Holy Spirit to save mankind from sin.",
    scriptures: ["Isaiah 7:14", "Matthew 1:18–22", "Luke 1:26–38", "Romans 1:4"],
  },
  {
    id: 4,
    title: "The Sinfulness of All Men",
    summary:
      "All men are born sinners through the fall of Adam and Eve and are worthy of God's wrath apart from Christ.",
    scriptures: ["Psalm 51:5", "Job 14:4", "Romans 3:23", "Romans 5:12–17", "Ephesians 2:1"],
  },
  {
    id: 5,
    title: "Repentance",
    summary:
      "Genuine repentance comes through faith: admit you are a sinner, identify your sins, confess them, forsake the pleasure of sin and the world, and be ready for restitution.",
    scriptures: ["Proverbs 28:13", "Isaiah 55:7", "Acts 2:38", "2 Corinthians 7:10", "Luke 13:1–5"],
  },
  {
    id: 6,
    title: "Faith in Christ",
    summary:
      "Faith is giving your life to Jesus and relying on Him — believing His birth, name, words, sufferings, blood, death, Spirit, resurrection, and ascension.",
    scriptures: ["Romans 10:9–10", "John 9:35–38", "Hebrews 11:1", "Ephesians 2:8"],
  },
  {
    id: 7,
    title: "Restitution",
    summary:
      "Restitution is the amendment of wrongdoings — returning stolen goods, confessing sins to victims, and seeking forgiveness to maintain a good conscience before God and man.",
    scriptures: ["Leviticus 6:1–7", "Luke 19:8–9", "Acts 26:20", "Matthew 3:8"],
  },
  {
    id: 8,
    title: "Justification",
    summary:
      "Justification is the saving grace of God for sinners who rely entirely on Christ — sins removed and the believer regarded as righteous before God.",
    scriptures: ["Romans 3:24–30", "Galatians 2:16", "Titus 3:5", "2 Corinthians 5:17–21"],
  },
  {
    id: 9,
    title: "Water Baptism",
    summary:
      "A cardinal teaching following repentance and faith. The believer is immersed once in the name of the Father, Son, and Holy Spirit — dead to sin and alive to God.",
    scriptures: ["Matthew 28:19", "Romans 6:4–5", "Mark 1:9–11", "Acts 2:38"],
  },
  {
    id: 10,
    title: "The Lord's Supper",
    summary:
      "Instituted by Jesus to remember His death until He returns, using unleavened bread and the fruit of the vine as symbols of His body and blood.",
    scriptures: ["Matthew 26:29", "Luke 22:17–20", "1 Corinthians 11:23–30", "Exodus 12:1–14"],
  },
  {
    id: 11,
    title: "Entire Sanctification",
    summary:
      "A gracious work of God in the saved whereby adamic and generational natures are removed, producing godliness, holiness, and peace.",
    scriptures: ["1 Thessalonians 4:3–7", "Hebrews 12:14", "1 Peter 1:14–16", "Ephesians 5:25–27"],
  },
  {
    id: 12,
    title: "Prayer",
    summary:
      "Prayer is communion with God and spiritual warfare against Satan. Its ingredients include faith, fasting, zeal, and charity.",
    scriptures: ["Luke 18:1–8", "Matthew 6:13", "Ephesians 6:18", "Matthew 7:7"],
  },
  {
    id: 13,
    title: "Fasting",
    summary:
      "Abstinence from food and drink to humble the soul and seek the Holy Spirit — including three-day, seven-day, and extended fasts.",
    scriptures: ["Matthew 4:2", "Exodus 34:28", "Matthew 17:21", "Acts 13:2–3"],
  },
  {
    id: 14,
    title: "Holy Ghost Baptism",
    summary:
      "Divine empowerment for service, often evidenced by speaking in new tongues and bold witness for Christ.",
    scriptures: ["Acts 1:8", "Acts 2:4", "Luke 3:16", "Mark 16:17"],
  },
  {
    id: 15,
    title: "Fruits of the Spirit",
    summary:
      "Love, joy, peace, longsuffering, kindness, goodness, faithfulness, gentleness, and self-control — the evidence of abiding in Christ.",
    scriptures: ["Galatians 5:22–23", "John 15:1–8", "Matthew 7:15–21"],
  },
  {
    id: 16,
    title: "Gifts of the Spirit",
    summary:
      "Speaking in tongues, prophecy, wisdom, knowledge, discernment, miracles, and healing — to be exercised in holiness, not for show.",
    scriptures: ["1 Corinthians 12:8–11", "Romans 12:6–8", "Matthew 7:20–23"],
  },
  {
    id: 17,
    title: "Signs, Wonders and Miracles",
    summary:
      "God still works wonders as testimony to His promise, yet the saving word of God remains most essential.",
    scriptures: ["Hebrews 2:1–4", "John 14:11", "Romans 1:16", "1 Corinthians 1:18"],
  },
  {
    id: 18,
    title: "Redemption from Curse, Healing and Health",
    summary:
      "Health and wholeness are provided through the suffering and blood of Jesus Christ our Healer.",
    scriptures: ["Isaiah 53:3–5", "Matthew 8:16–17", "James 5:14–16", "Galatians 3:13–14"],
  },
  {
    id: 19,
    title: "Evangelism",
    summary:
      "God's commission for every believer to bring others to Christ through witness and discipleship.",
    scriptures: ["Matthew 28:19–20", "Mark 16:15", "Acts 1:8", "Proverbs 11:30"],
  },
  {
    id: 20,
    title: "The Christian Family",
    summary:
      "The family is God's union of a man and woman. The man leads in love; the woman supports; children are nurtured in the fear of the Lord.",
    scriptures: ["Genesis 2:24–25", "Ephesians 5:21–33", "Colossians 3:18–21", "1 Peter 3:1–7"],
  },
  {
    id: 21,
    title: "Marriage",
    summary:
      "An institution between a mature man and woman — monogamous and lifelong. New Testament teaching does not permit divorce while a spouse lives.",
    scriptures: ["Matthew 19:3–9", "Hebrews 13:4", "1 Corinthians 7:10–11", "Proverbs 18:22"],
  },
  {
    id: 22,
    title: "The Church of God",
    summary:
      "The model of the heavenly church — an embassy for repentant believers and a place of spiritual nourishment, teaching, and care.",
    scriptures: ["Hebrews 10:25", "Ephesians 4:11–16", "Acts 2:42–47"],
  },
  {
    id: 23,
    title: "Christian Ceremonies",
    summary:
      "Ceremonies should glorify God, not fund-raise or lead to debt. Members celebrate with gratitude; invites assist and give as led.",
    scriptures: ["Ecclesiastes 3:1", "1 Corinthians 10:31", "Romans 12:15"],
  },
  {
    id: 24,
    title: "Charity",
    summary:
      "Good measure, pressed down — tithes, offerings to the poor, and willing gifts to God and His work.",
    scriptures: ["Luke 6:38", "Malachi 3:10", "Proverbs 19:17", "2 Corinthians 9:7"],
  },
  {
    id: 25,
    title: "The Will of God",
    summary:
      "Seek what is acceptable to God and walk in the wisdom of His will, as David and Paul exemplified.",
    scriptures: ["Romans 12:2", "Ephesians 5:17", "Psalm 143:10", "1 Thessalonians 4:3"],
  },
  {
    id: 26,
    title: "Doing Things in the Right Way",
    summary:
      "There is a God-appointed time and pattern for everything. Obedience to biblical order honours the Lord.",
    scriptures: ["Ecclesiastes 3:1", "Deuteronomy 12:32", "1 Corinthians 14:40"],
  },
  {
    id: 27,
    title: "The Christian's Cross",
    summary:
      "Self-denial and daily following of Christ — if any man will follow Me, let him deny himself and take up his cross.",
    scriptures: ["Matthew 16:24", "Luke 9:23", "Galatians 2:20", "Philippians 3:8"],
  },
  {
    id: 28,
    title: "The Rapture",
    summary:
      "The catching away of saints — the first major eschatological event separating the redeemed from the world.",
    scriptures: ["1 Thessalonians 4:16–17", "1 Corinthians 15:51–52", "John 14:1–3"],
  },
  {
    id: 29,
    title: "Resurrection of the Dead",
    summary:
      "All souls shall rise: Christ first, then Old Testament saints, tribulation saints, and New Testament saints.",
    scriptures: ["1 Corinthians 15:20–23", "Daniel 12:2", "Revelation 20:4–6"],
  },
  {
    id: 30,
    title: "Christ's Throne of Judgment (Bema)",
    summary:
      "The judgment of the redeemed after the Rapture for rewards according to works — not for sin, but for eternal profit.",
    scriptures: ["2 Corinthians 5:10", "Romans 14:10–12", "1 Corinthians 3:11–15"],
  },
];
